<template>
  <iColumn
    :width="getOptionValue(LayoutWidth) || 'hug'"
    height="hug"
    :style-overrides="appInputWrapperStyleOverrides"
  >
    <MediaPickerField v-model="value" media-type="video" :label="labelValue" />
  </iColumn>
</template>

<script>
import { plainLabelText } from "%/dynamic-component-editor/helpers/plain-label-text.mjs";
import MediaPickerField from "%/components/MediaPickerField.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import DynamicAppInputOptionsMixin from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/inputs/dynamic-app-input-options-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import Label from "%/dynamic-component-editor/options/label";

import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";

export default {
  name: "DynamicAppVideoInputElement",
  components: {
    MediaPickerField,
  },
  mixins: [DynamicElementMixin, DynamicElementWithContext, DynamicAppInputOptionsMixin],
  elementPanelSettings: {
    displayName: "Text",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  options: [
    Label,
    BackgroundColor,
    BorderColor,
    BorderWidth,
  ],
  optionBundles: [
    new BasicTextOptions({}, {
      "font-family": true,
    }),
    new LayoutWidthHeightOptions({}, {
      "layout-height": true,
      "max-width": true,
      "max-height": true,
      "min-width": true,
      "min-height": true,
    }),
    new SpacingOptions(),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  hidden: true,
  computed: {
    LayoutWidth() {
      return LayoutWidth;
    },
    labelValue() {
      return plainLabelText(this.getOptionValue(Label));
    },
    value: {
      get() {
        return this.valueFromContext;
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = value;
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
